import StyleSheet from '../../utils/helpers/styleSheet'
import {useAppDispatch} from '../../stores/configureStore'
import PlusIcon from '../icons/PlusIcon'
import {ImgMasked} from '../../models/editor/imgMasked'
import {selectToolboxTabPanel} from '../../stores/toolbox/toolbox.reducer'
import {Config} from '../../constants/Config'
import {useTranslation} from 'react-i18next'

const styles: StyleSheet = {
  button: {
    display: 'flex',
    flexDirection: 'column',
    marginRight: 15,
    cursor: 'pointer',
    alignItems: 'center',
  },
  preview: {
    cursor: 'pointer',
    height: 30,
    objectFit: 'contain',
  },
  icon: {
    cursor: 'pointer',
    height: 30,
  },
  text: {
    textAlign: 'center',
    minWidth: 110,
  },
}

interface SelectImageButtonProps {
  img: ImgMasked
  index: number
}

export default function SelectImageButton({
  img,
  index,
}: SelectImageButtonProps) {
  const {t} = useTranslation()
  const dispatch = useAppDispatch()
  const insideImage = img.inside[index]

  return (
    <div
      style={styles.button}
      onClick={() => {
        dispatch(
          selectToolboxTabPanel({
            tabPanel: 'PhotoUpload',
            selectForMasked: {id: img.id, insideIndex: index},
          }),
        )
      }}>
      {insideImage.url &&
      insideImage.url !==
        `${Config.websiteUrl}/wp-content/themes/poloforma/assets/mask_placeholder.png` ? (
        <img src={insideImage.url} alt="" style={styles.preview} />
      ) : (
        <PlusIcon
          title={t('Hozzáadás')}
          style={styles.icon}
          className="icon"
          width={30}
          height={30}
        />
      )}
      <span className="text" style={styles.text}>
        {insideImage.url ? t('Csere') : t('Hozzáadás')}
      </span>
    </div>
  )
}
